import { canBindList, type TaxonomyField } from '@/entities/taxonomy';

/**
 * Applies one field's patch to the schema's fields.
 *
 * A subfield belongs to its parent's SECTION, so a group change carries the whole cluster: Media
 * and Content render as separate tables, and a subfield left behind would show up as an orphan
 * column joined into the name with the wrong delimiter.
 *
 * A binding cannot outlive the type that justified it. That is decided on the MERGED field, never
 * on the patch: the link dialog sends a `listRef` and no `type`, so a patch alone cannot tell
 * whether the pair is legal. Both rules live here, not in the dialogs, because every grid and
 * dialog edit to one field's type or group comes through this function.
 */
export function applyFieldPatch(
  fields: TaxonomyField[],
  id: string,
  patch: Partial<TaxonomyField>,
): TaxonomyField[] {
  return fields.map((f) => {
    if (f.id === id) {
      const next = { ...f, ...patch };
      return next.listRef && !canBindList(next.type) ? { ...next, listRef: undefined } : next;
    }
    if (patch.group && f.parentId === id) return { ...f, group: patch.group };
    return f;
  });
}
